module.exports = __webpack_public_path__ + "static/sqlserver-4895f2d556759cc906341c5f47c16514.svg";